import PageHeader from "@/components/site/PageHeader";
import ContactForm from "@/components/site/ContactForm";
import { useSEO } from "@/lib/seo";
import { OFFICES } from "@/lib/content";
import { MapPin } from "lucide-react";
import { motion } from "framer-motion";

export default function Kontakt() {
    useSEO({
        title: "Kontakt",
        description:
            "Ta kontakt med BM Juridik. Vi finns i Stockholm, Göteborg, Malmö, Uppsala, Jönköping och Herrljunga. Fyll i formuläret så återkommer vi inom 24 timmar.",
    });
    return (
        <div data-testid="page-kontakt">
            <PageHeader
                kicker="Kontakt"
                title="Tala med oss om"
                accent="ditt ärende."
                description="Vårt första samtal är alltid förutsättningslöst. Fyll i formuläret, ring oss, eller besök något av våra sex kontor runt om i Sverige."
                image="https://images.pexels.com/photos/5668484/pexels-photo-5668484.jpeg"
            />

            <section
                data-testid="offices-grid"
                className="py-20 bg-[#0A0A0B] border-t border-white/5"
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
                        <div>
                            <p className="overline">Våra kontor</p>
                            <h2 className="mt-4 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
                                Sex kontor,{" "}
                                <span className="italic text-[#C4A977]">
                                    en byrå
                                </span>
                                .
                            </h2>
                        </div>
                        <p className="max-w-md text-sm text-[#A1A1AA] leading-relaxed">
                            Vi finns nära våra klienter — oavsett om ditt ärende
                            kräver ett möte i centrala Stockholm eller i vår
                            lokal i Herrljunga.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                        {OFFICES.map((o, i) => (
                            <motion.div
                                key={o.city}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.6, delay: i * 0.06 }}
                                data-testid={`office-card-${o.city.toLowerCase()}`}
                                className="group bg-[#111113] border border-white/5 hover:border-[#C4A977]/40 p-7 rounded-sm transition-colors duration-500"
                            >
                                <div className="w-11 h-11 border border-[#C4A977]/40 grid place-items-center text-[#C4A977]">
                                    <MapPin size={16} />
                                </div>
                                <p className="mt-5 overline">{o.city}</p>
                                <p className="mt-3 font-serif text-xl text-[#F4F4F5] leading-snug">
                                    {o.address}
                                </p>
                                <p className="mt-2 text-sm text-[#A1A1AA]">
                                    {o.postal}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <ContactForm />
        </div>
    );
}
